import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackBarComponent } from './snackbar.component';
import { SnackBarPosition } from './snackbar.constant';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private defaultPosition: SnackBarPosition = {
    vertical: 'bottom',
    horizontal: 'left',
  };
  private defaultDuration = 5000;

  constructor(private matSnackBar: MatSnackBar) {}

  openSnackBar(data, position?: SnackBarPosition, duration?: number): MatSnackBarRef<any> {
    return this.matSnackBar.openFromComponent(SnackBarComponent, {
      data,
      duration: duration ?? this.defaultDuration,
      horizontalPosition: !position ? this.defaultPosition.horizontal : position.horizontal,
      verticalPosition: !position ? this.defaultPosition.vertical : position.vertical,
    });
  }
}
